import { isNapflixOSMode } from "./napflixOS";

// NapflixOS Runtime Layer v2
// Lightweight OS/runtime state spine. No UI behavior lives here.
const IDLE_TIMEOUT_MS = 90 * 1000;

let idleTimer = null;

let systemState = {
  isNapflixOS: isNapflixOSMode(),
  isFullscreen:
    typeof document !== "undefined" ? !!document.fullscreenElement : false,
  isIdle: false,
  lastInputAt: Date.now(),
  networkOnline:
    typeof navigator !== "undefined" ? navigator.onLine !== false : true,
  playbackActive: false,
  ambientMode: false,
  remoteActive: false,
};

const listeners = new Set();

export function getSystemState() {
  return systemState;
}

export function setSystemState(partial) {
  systemState = {
    ...systemState,
    ...partial,
  };

  listeners.forEach((listener) => listener(systemState));
}

export function subscribeSystemState(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

const markInputActive = () => {
  window.clearTimeout(idleTimer);

  setSystemState({
    isIdle: false,
    lastInputAt: Date.now(),
    remoteActive: true,
  });

  idleTimer = window.setTimeout(() => {
    setSystemState({ isIdle: true });
  }, IDLE_TIMEOUT_MS);
};

export function installSystemStateRuntime() {
  if (typeof window === "undefined") {
    return () => {};
  }

  const updateFullscreen = () => {
    setSystemState({ isFullscreen: !!document.fullscreenElement });
  };

  const updateNetworkOnline = () => {
    setSystemState({ networkOnline: navigator.onLine !== false });
  };

  setSystemState({
    isNapflixOS: isNapflixOSMode(),
    isFullscreen: !!document.fullscreenElement,
    networkOnline: navigator.onLine !== false,
  });

  if (!getSystemState().isNapflixOS) {
    return () => {};
  }

  document.addEventListener("fullscreenchange", updateFullscreen);
  window.addEventListener("online", updateNetworkOnline);
  window.addEventListener("offline", updateNetworkOnline);
  window.addEventListener("keydown", markInputActive);
  window.addEventListener("mousemove", markInputActive, { passive: true });
  window.addEventListener("mousedown", markInputActive, { passive: true });
  window.addEventListener("touchstart", markInputActive, { passive: true });
  markInputActive();

  return () => {
    window.clearTimeout(idleTimer);
    document.removeEventListener("fullscreenchange", updateFullscreen);
    window.removeEventListener("online", updateNetworkOnline);
    window.removeEventListener("offline", updateNetworkOnline);
    window.removeEventListener("keydown", markInputActive);
    window.removeEventListener("mousemove", markInputActive);
    window.removeEventListener("mousedown", markInputActive);
    window.removeEventListener("touchstart", markInputActive);
  };
}
